import {
  imprimirHtmlQz,
  imprimirTextoQz,
  imprimirTicketsProducao,
} from "./qzTrayPrinter";

let producaoEmAndamento = null;
let pedidoCompletoEmAndamento = null;
let cicloEmAndamento = null;

export function imprimirProducaoPendente(http) {
  if (producaoEmAndamento) return producaoEmAndamento;

  producaoEmAndamento = (async () => {
    const { data } = await http.post("/restaurante/producao/impressao-pendente", {
      limite: 20,
    });
    if (!Array.isArray(data) || !data.length) return;

    const token = data[0].token;
    if (!token || data.some((ticket) => ticket.token !== token)) {
      throw new Error("Reserva de impressão da produção inválida.");
    }

    let ids = [];
    let falha = null;
    try {
      ids = await imprimirTicketsProducao(data);
    } catch (error) {
      falha = error;
    }

    const impressos = new Set(ids);
    const falhos = data.flatMap((ticket) =>
      (Array.isArray(ticket.ids) ? ticket.ids : [ticket.id]).filter(
        (id) => id && !impressos.has(id)
      )
    );

    await http.post("/restaurante/producao/marcar-impresso", {
      ids,
      falhos,
      token,
    });

    if (falha) throw falha;
    if (falhos.length) {
      throw new Error("Alguns tickets da produção não foram impressos.");
    }
  })().finally(() => {
    producaoEmAndamento = null;
  });

  return producaoEmAndamento;
}

export function imprimirPedidoCompletoPendente(http) {
  if (pedidoCompletoEmAndamento) return pedidoCompletoEmAndamento;

  pedidoCompletoEmAndamento = (async () => {
    const { data } = await http.post(
      "/restaurante/producao/impressao-delivery-pendente"
    );
    if (!Array.isArray(data) || !data.length) return;

    let primeiraFalha = null;
    for (const ticket of data) {
      try {
        if (!ticket?.impressora || (!ticket?.conteudo_raw && !ticket?.conteudo)) {
          throw new Error(
            "Pedido completo sem impressora ou conteúdo para impressão."
          );
        }

        if (ticket.conteudo_raw || ticket.formato === "raw") {
          await imprimirTextoQz(
            ticket.impressora,
            ticket.conteudo_raw || ticket.conteudo,
            { cortar: true }
          );
        } else {
          await imprimirHtmlQz(ticket.impressora, ticket.conteudo);
        }

        await http.post(
          `/restaurante/producao/impressao-delivery/${ticket.id}/marcar-impresso`,
          { token: ticket.token, impresso: true }
        );
      } catch (error) {
        if (ticket?.id && ticket?.token) {
          try {
            await http.post(
              `/restaurante/producao/impressao-delivery/${ticket.id}/marcar-impresso`,
              { token: ticket.token, impresso: false }
            );
          } catch (releaseError) {
            // A falha original da impressão/confirmacao continua sendo a mais útil.
          }
        }
        if (!primeiraFalha) primeiraFalha = error;
      }
    }

    if (primeiraFalha) throw primeiraFalha;
  })().finally(() => {
    pedidoCompletoEmAndamento = null;
  });

  return pedidoCompletoEmAndamento;
}

export function processarFilaImpressao(
  http,
  { repetirSeOcupado = false, onError } = {}
) {
  if (cicloEmAndamento) {
    return repetirSeOcupado
      ? cicloEmAndamento.then(() =>
          processarFilaImpressao(http, { onError })
        )
      : cicloEmAndamento;
  }

  cicloEmAndamento = (async () => {
    for (const processar of [
      () => imprimirPedidoCompletoPendente(http),
      () => imprimirProducaoPendente(http),
    ]) {
      try {
        await processar();
      } catch (error) {
        if (onError) onError(error);
      }
    }
  })().finally(() => {
    cicloEmAndamento = null;
  });

  return cicloEmAndamento;
}
